import { ShieldCheck, Zap, Users } from "lucide-react";
import { Reveal, ScrollHeading, Eyebrow } from "./ui";
const values = [
  {
    title: "Understand the problem",
    icon: ShieldCheck,
    description:
      "We start with your goals, users, and existing systems so the work addresses the right problem.",
  },
  {
    title: "Choose what fits",
    icon: Zap,
    description:
      "We recommend technologies and a scope that fit your budget, team, and long-term needs.",
  },
  {
    title: "Work together",
    icon: Users,
    description:
      "You stay involved through clear discussions, regular reviews, and shared decisions.",
  },
];
export function Intro() {
  return (
    <section className="values section-pad" id="learn-more">
      <div className="wrap">
        <Reveal className="section-heading values-heading">
          <Eyebrow number="01">Our approach</Eyebrow>
          <ScrollHeading
            lines={[
              { text: "How we work", muted: false },
              { text: "with you.", muted: true },
            ]}
          />
        </Reveal>
        <div className="values-grid">
          {values.map(({ title, description, icon: Icon }, index) => (
            <Reveal key={title} delay={index * 0.08} className="value-card">
              <div className="value-top">
                <Icon size={27} strokeWidth={1.35} />
                <span>0{index + 1}</span>
              </div>
              <h3>{title}</h3>
              <p>{description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
